import HTransformObject from "./transform-object.helper";

/**
 * Create query string from object
 * @param object - object to be converted to query string
 * @param add - add "?" to the query string
 * @example
 * H_createQuery({name: "John", age: 30},true) // returns "?name=John&age=30"
 * H_createQuery({name: "John", age: 30}) // returns "name=John&age=30"
 * don't add "?" if working with fetchBaseQuery
 * @see fetchBaseQuery
 * @returns query string
 */
export const HCreateQuery = (object: any) => {
  const params = HTransformObject(object, {
    noTransformArrayToObject: true,
    removeEmptyArray: true,
    removeEmptyStrings: true,
    removeUndefined: true
  });

  if (params === null || params === undefined) return "";

  return Object.keys(params).length === 0
    ? ""
    : `${new URLSearchParams(params).toString()}`;
};
